var _style, _g, _g2, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAe3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "904.3px",
    height: "904.3px",
    viewBox: "0 0 904.3 904.3",
    style: {
      enableBackground: "new 0 0 904.3 904.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#3B414F;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#3B414F;stroke-width:27.3187;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M445.7,212c94.1,0,188.2,0,282.4,0c3.6,0,7.2,0.3,10.7,0.9c7,1.4,11.1,5.8,12,12.9c0.5,3.7,0.5,7.5,0.5,11.3 c0.1,8.1,0,16.3,0,24.4c0,6.2,1.9,11.5,7.2,15.2c2.6,1.8,4.9,4.1,7.5,6.1c4.4,3.4,6.3,7.9,6.2,13.3c0,17.2,0,34.4,0,51.6 c0,109.1,0,218.3,0,327.4c0,12.9-4.8,18.6-17.6,20.7c-41.6,7.1-83.4,12.6-125.4,16.9c-73,7.4-146.2,10.2-219.6,8.9 c-41.1-0.8-82.2-3-123.2-6.5c-50.6-4.4-101-11-151.1-19.3c-10.6-1.8-16.2-8.6-16.2-19.8c0-101,0-202,0-303c0-24.7,0.1-49.4-0.1-74 c-0.1-7.6,2-13.7,8.6-18c2.1-1.4,3.9-3.3,5.9-4.8c4.1-3,6.2-7.2,6.3-12.2c0.2-9.9,0.2-19.9,0.3-29.8c0-2.3,0.1-4.5,0.3-6.8 c0.8-9,5.8-14.1,14.8-15c2.8-0.3,5.7-0.4,8.5-0.4C257.7,212,351.7,212,445.7,212z M445.7,213.3c-94,0-188.1,0-282.1,0 c-2.6,0-5.3,0-7.9,0.2c-8.7,0.8-13.4,5.5-14.2,14.1c-0.2,2.4-0.2,4.9-0.2,7.4c-0.1,9.9-0.1,19.9-0.4,29.8 c-0.1,4.9-2.4,9.1-6.4,12.1c-2.3,1.7-4.3,3.8-6.6,5.4c-5.5,3.8-7.5,9-7.5,15.5c0.1,126.2,0.1,252.5,0.1,378.7c0,1.9,0,3.8,0.5,5.6 c2.1,8.1,8.1,11.3,15.8,12.5c36.6,6.1,73.3,11.5,110.2,15.2c27.8,2.7,55.5,5.3,83.4,7.1c25.6,1.7,51.2,2.5,76.8,3.2 c51.6,1.4,103.1,0.3,154.6-3.2c29.5-2,59-4.4,88.4-7.9c35.3-4.2,70.4-9.7,105.6-14.6c2.1-0.3,4.3-1,6.2-1.9 c7.1-3.4,9.1-9.5,9.1-16.9c0-102.5,0-205,0-307.5c0-23.9,0-47.8,0-71.8c0-5.3-1.7-9.6-6-12.8c-2.3-1.7-4.3-3.8-6.6-5.4 c-6.2-4.2-8.4-10.2-8.3-17.3c0-8.3,0-16.6,0-25c0-3.1,0-6.3-0.4-9.3c-0.9-7.3-4.5-11.3-11.7-12.6c-3.4-0.6-7-0.7-10.4-0.7 C633.6,213.3,539.7,213.3,445.7,213.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M445.7,213.3c93.9,0,187.9,0,281.8,0c3.5,0,7,0.1,10.4,0.7c7.2,1.3,10.9,5.3,11.7,12.6 c0.4,3.1,0.3,6.2,0.4,9.3c0.1,8.3,0.1,16.6,0,25c0,7.2,2.2,13.1,8.3,17.3c2.3,1.6,4.3,3.7,6.6,5.4c4.3,3.2,6,7.5,6,12.8 c0,23.9,0,47.8,0,71.8c0,102.5-0.1,205,0,307.5c0,7.4-2,13.5-9.1,16.9c-1.9,0.9-4.1,1.6-6.2,1.9c-35.2,5-70.3,10.5-105.6,14.6 c-29.4,3.5-58.9,5.8-88.4,7.9c-51.5,3.5-103,4.6-154.6,3.2c-25.6-0.7-51.3-1.5-76.8-3.2c-27.8-1.8-55.6-4.4-83.4-7.1 c-36.9-3.6-73.6-9-110.2-15.2c-7.6-1.3-13.7-4.4-15.8-12.5c-0.5-1.8-0.5-3.7-0.5-5.6c0-126.2,0-252.5-0.1-378.7 c0-6.6,2-11.8,7.5-15.5c2.3-1.6,4.3-3.7,6.6-5.4c4-3.1,6.3-7.2,6.4-12.1c0.3-9.9,0.2-19.8,0.4-29.8c0-2.5,0-4.9,0.2-7.4 c0.8-8.7,5.5-13.3,14.2-14.1c2.6-0.2,5.3-0.2,7.9-0.2C257.7,213.3,351.7,213.3,445.7,213.3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 236.9,
    y1: 321.8,
    x2: 236.9,
    y2: 379.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 236.9,
    y1: 409.7,
    x2: 236.9,
    y2: 467.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 236.9,
    y1: 494.6,
    x2: 236.9,
    y2: 552.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 231.8,
    y1: 592.7,
    x2: 203.4,
    y2: 641.9
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 345.8,
    y1: 321.8,
    x2: 345.8,
    y2: 379.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 345.8,
    y1: 409.7,
    x2: 345.8,
    y2: 467.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 345.8,
    y1: 494.6,
    x2: 345.8,
    y2: 552.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 340.7,
    y1: 592.7,
    x2: 312.2,
    y2: 641.9
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 437.8,
    y1: 321.8,
    x2: 437.8,
    y2: 379.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 437.8,
    y1: 409.7,
    x2: 437.8,
    y2: 467.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 437.8,
    y1: 494.6,
    x2: 437.8,
    y2: 552.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 437.8,
    y1: 588.3,
    x2: 437.8,
    y2: 646.4
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 529.9,
    y1: 321.8,
    x2: 529.9,
    y2: 379.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 529.9,
    y1: 409.7,
    x2: 529.9,
    y2: 467.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 529.9,
    y1: 494.6,
    x2: 529.9,
    y2: 552.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 535,
    y1: 592.7,
    x2: 563.5,
    y2: 641.9
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 638.8,
    y1: 321.8,
    x2: 638.8,
    y2: 379.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 638.8,
    y1: 409.7,
    x2: 638.8,
    y2: 467.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 638.8,
    y1: 494.6,
    x2: 638.8,
    y2: 552.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 643.9,
    y1: 592.7,
    x2: 672.3,
    y2: 641.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAe3);
export default __webpack_public_path__ + "static/media/ae3.9809ed524d9d7f1fafcd0c06f71fbf2f.svg";
export { ForwardRef as ReactComponent };